import {
  SAVE_MODULE_TEMPLATES,
  SURVEY_SET_DATA,
  SET_LOADING,
} from '../actions';

const initialState = {
  templates: [],
  singleTemplate: undefined,
  loading: {},
  pagination: {
    current: 1,
    total: undefined,
    pageSize: 10,
  },
  hubList: [],
  showSurveyCreationModal: false,
  showHubSelectionModal: false,
  showModuleSelectionModal: false,
  selectedGroups: [],
  selectedHubs: [],
  hubsSurveys: undefined,
  showSurveyForm: false,
  surveyData: {},
  preSelectedHubs: [],
  copyFromSurvey: false,
};

const surveyProvisioningReducer = (state = initialState, { type, data }) => {
  switch (type) {
    case SAVE_MODULE_TEMPLATES:
      return {
        ...state,
        templates: data,
      };
    case SURVEY_SET_DATA:
      return {
        ...state,
        ...data,
      };
    case SET_LOADING:
      return {
        ...state,
        loading: {
          ...state.loading,
          ...data,
        },
      };
    default:
      return state;
  }
};

export default surveyProvisioningReducer;
